import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAuth = ({ allowedRole }) => {
  const { auth } = useAuth();
  const location = useLocation();

  const allowedRoles = allowedRole.split(',').map(r => r.trim().toLowerCase());
  const userRole = auth?.role?.toLowerCase();

  return (
    allowedRoles.includes(userRole)
      ? <Outlet />
      : auth?.user
        ? <Navigate to="/" replace />
        : <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
